import { useState } from 'react'

import { Page } from '@/components/layout/page/page'
import { useRoles } from '@/modules/team/hooks/use-roles'
import { TeamRoleCreateDialog } from '@/modules/team/ui/roles/list/team-role-create-dialog'
import { TeamRoleHeaderActions } from '@/modules/team/ui/roles/list/team-role-header-actions'
import { TeamPageSkeleton } from '@/modules/team/ui/team-page-skeleton'
import { TeamRoles } from '@/modules/team/views/roles/team-roles'

export const TeamRolesView = () => {
  const [searchValue, setSearchValue] = useState<string | null>(null)
  const { data, isFetching } = useRoles(searchValue)

  const [createNewRole, setCreateNewRole] = useState(false)

  if (isFetching || !data) {
    return <TeamPageSkeleton />
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleCreateNew = () => {
    setCreateNewRole(true)
  }

  return (
    <Page
      title="Roles"
      headerOptions={
        <TeamRoleHeaderActions
          onCreateNew={handleCreateNew}
          onSearch={setSearchValue}
        />
      }
      description="Assign team members to pre-defined and custom roles for easier management"
    >
      <TeamRoles roles={data} />
      <TeamRoleCreateDialog
        shoCreateRoleDialog={createNewRole}
        setShowCreateRoleDialog={setCreateNewRole}
      />
    </Page>
  )
}
